import React from 'react';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

const Breadcrumbs = ({ items, separator, onItemDragOver, onItemDrop }) => {
  return (
    <Breadcrumb spacing="8px" mb="24px" separator={separator}>
      {items.map((item, index) => (
        <BreadcrumbItem key={index}>
          <BreadcrumbLink
            as={item.to ? Link : 'span'}
            to={item.to}
            isCurrentPage={item.isCurrentPage}
            fontWeight={item.isCurrentPage ? 700 : 400}
            textDecor={item.to || item.onClick ? 'underline' : 'none'}
            onClick={item.onClick}
            cursor={item.onClick ? 'pointer' : undefined}
            onDragOver={onItemDragOver ? (e) => onItemDragOver(e, item) : undefined}
            onDrop={onItemDrop ? (e) => onItemDrop(e, item) : undefined}
          >
            {item.label}
          </BreadcrumbLink>
        </BreadcrumbItem>
      ))}
    </Breadcrumb>
  );
};

export default Breadcrumbs;